const getAssetUrl = (path: string | undefined): string => {
  if (!path) return '';

  const s3Url = 'https://tricao-production.s3.us-west-2.amazonaws.com';
  // Use env var or default to S3.
  // Ensure we don't have double slashes if the env var ends with /
  const rawAssetUrl = process.env.REACT_APP_ASSETS_URL || s3Url;
  const assetUrl = rawAssetUrl.endsWith('/') ? rawAssetUrl.slice(0, -1) : rawAssetUrl;

  // If the path is already the S3 URL, replace it with the asset URL
  if (path.includes(s3Url)) {
    return path.replace(s3Url, assetUrl);
  }

  // If it's another absolute URL, leave it alone
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Otherwise treat as relative path
  const cleanPath = path.startsWith('/') ? path : `/${path}`;

  return `${assetUrl}${cleanPath}`;
};

export default getAssetUrl;
